module.exports = __webpack_public_path__ + "img/cellphone-example.17b00583.png";